export const ValidColumnOrder = () => {
  return (
    <svg viewBox="0 0 270 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="59" height="19" rx="3.5" fill="#EFF8FD" stroke="#CAD8DE" />
      <rect x="0.5" y="39.5" width="59" height="19" rx="3.5" fill="#EFF8FD" stroke="#CAD8DE" />
      <rect x="140.5" y="0.5" width="59" height="19" rx="3.5" fill="#EFF8FD" stroke="#CAD8DE" />
      <rect x="140.5" y="39.5" width="59" height="19" rx="3.5" fill="#EFF8FD" stroke="#CAD8DE" />
      <rect x="70.5" y="0.5" width="59" height="19" rx="3.5" fill="#F6F8FA" stroke="#CAD8DE" />
      <rect x="70.5" y="39.5" width="59" height="19" rx="3.5" fill="#F6F8FA" stroke="#CAD8DE" />
      <rect x="210.5" y="0.5" width="59" height="19" rx="3.5" fill="#F6F8FA" stroke="#CAD8DE" />
      <rect x="210.5" y="39.5" width="59" height="19" rx="3.5" fill="#F6F8FA" stroke="#CAD8DE" />
      <path d="M30 20V37.5L30 39" stroke="#5DD39E" strokeWidth="2" />
      <circle cx="30" cy="19" r="5" fill="#5DD39E" />
      <circle cx="30" cy="19" r="2" fill="white" />
      <circle cx="30" cy="39" r="5" fill="#5DD39E" />
      <circle cx="30" cy="39" r="2" fill="white" />
      <path d="M170 39.5L100 19" stroke="#FB8087" strokeWidth="2" />
      <path d="M170 19L100 39.5" stroke="#FB8087" strokeWidth="2" />
      <circle cx="100" cy="19" r="5" fill="#FB8087" />
      <circle cx="100" cy="19" r="2" fill="white" />
      <circle cx="100" cy="39" r="5" fill="#FB8087" />
      <circle cx="100" cy="39" r="2" fill="white" />
      <circle cx="170" cy="19" r="5" fill="#FB8087" />
      <circle cx="170" cy="19" r="2" fill="white" />
      <circle cx="170" cy="39" r="5" fill="#FB8087" />
      <circle cx="170" cy="39" r="2" fill="white" />
      <path d="M240 20V37.5L240 39" stroke="#5DD39E" strokeWidth="2" />
      <circle cx="240" cy="19" r="5" fill="#5DD39E" />
      <circle cx="240" cy="19" r="2" fill="white" />
      <circle cx="240" cy="39" r="5" fill="#5DD39E" />
      <circle cx="240" cy="39" r="2" fill="white" />
    </svg>
  )
}
